import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Map from '../../map'
import {MarkerClusterer, ClusterIcon} from 'Vendor/gmaps-marker-clusterer'
import GoogleMarker from './googlemarker'

const Log = new Logger("StoreLocator/GoogleMap");

const ZOOMS = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18 ];

const _createCss_ = ClusterIcon.prototype.createCss;
const _setupStyles_ = MarkerClusterer.prototype.setupStyles_;

class GoogleMap extends Map {

  constructor(provider, element, options) {
    super(provider, element)

    this.BOUNDS_CHANGED_EVENT_NAME = "bounds_changed"
    this.IDLE_EVENT_NAME = "idle"
    this.SELECTPOINT_EVENT_NAME = "selectpoint"
    this.ZOOM_CHANGED_EVENT_NAME = "zoom_changed"
    this.DRAGEND_EVENT_NAME = "dragend"

    this.options["markerkey"] = this.options["markerkey"] || "key";

    let p = new Promise( (resolve) => {

      // Get the DOM element which use map in
      let mapEl = this.$element[0];

      // Use GoogleMap with default options
      this.Map = new google.maps.Map(mapEl, $.extend({}, {
        mapTypeControl: false,
        overviewMapControl: false,
        panControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        minZoom: 1,
        maxZoom: 18,
        zoom: 8,
        zoomControl: false,
        gestureHandling: "greedy"
      }, options) );

      this.Data = new google.maps.Data();

      google.maps.event.addListenerOnce(this.Map, "idle", () => {
        resolve(this);
      });

    });

    this._markers = {};

    return p;
  }



  setClusterTextColor(color) {
    let __cluster_text_color = color;
    ClusterIcon.prototype.createCss = function(pos) {
      __cluster_text_color && (this.textColor_ = __cluster_text_color);
      return _createCss_.call(this, pos);
    };
  }

  /* Sets the correct image sizes */

  setClusterIconDimensions(array) {
    if ( ! array ) {
      MarkerClusterer.prototype.setupStyles_ = _setupStyles_;
    } else {
      MarkerClusterer.prototype.setupStyles_ = function() {
        this.sizes = array;
        return _setupStyles_.call(this);
      };
    }
  }



  /**
   * @Override
   */
  navigate(bounds, switching) {

    if (this.Rectangle) {
      // remove older rectangle
      this.Rectangle.setMap(null);
    }

    if ( this.options.ShowMapRectangle ) {
      // Draw rectangle if requested
      this.drawOnMap( bounds );
    }

    // Move map to given bounds coordinates
    this.Map.fitBounds( bounds );

    // in case of fitst navigation `viewport` is undefined, so we return the `bounds`
    return this.Map.getBounds() || bounds;
  };


  /**
   * @Override
   */
  addPointToViewport(point) {
    let p = new google.maps.LatLng(point.lat, point.lng);
    let b = new google.maps.LatLngBounds( this.Map.getBounds().getSouthWest(), this.Map.getBounds().getNorthEast() );
    b.extend( p );
    return b;
  };

  static viewportFromBoundAndPoint(bounds, points){
    let b = new google.maps.LatLngBounds( bounds.getSouthWest(), bounds.getNorthEast() );
    for(let item of points) {
      const point = item.geometry.coordinates;
      b.extend(new google.maps.LatLng({lat: point[1], lng:point[0]}));
    }
    return b;

  }

  static includePinsIfInBound(bounds, points){
    let pins = [];
    let g_bounds = new google.maps.LatLngBounds({/*sw*/ lat: bounds.south, lng: bounds.west}, {/*ne*/ lat: bounds.north, lng: bounds.east});
    let Feats = points || [];
    for( let Feat of Feats ) {
      let g_point = new google.maps.LatLng({lat: Feat.geometry.coordinates[1], lng: Feat.geometry.coordinates[0]});
      if ( g_bounds.contains( g_point ) ) {
        pins.push( Feat );
      }
    }
    return pins;
  }



  /**
   * @Override
   */
  set center(point) {
    if ( !(point instanceof google.maps.LatLng) ) {
      point = new google.maps.LatLng( point );
    }
    this.Map.setCenter( point );
  };

  /**
   * @Override
   */
  get zoom() {
    // returns the index of zoom level
    return ZOOMS.indexOf( this.Map.getZoom() );
  }

  set zoom(index) {
    // Sets zoom level if contained into `ZOOMS` array
    ZOOMS[ index ] && this.Map.setZoom( ZOOMS[ index ] );
  }


  get Markers() {
    return this._markers;
  }

  getMarker(code) {
    return this.Markers[ code ];
  }


  /**
   * @Override
   */
  showMarker(points, use_cluster) {
    // remove all markers
    this.clearMarkers();

    let markers = [];

    if ( points && points.features && points.features.length > 0 ) {

      if ( use_cluster ) {

        if ( ! this.Clusters ) {
          // create a new clusterer class
          this.Clusters = new MarkerClusterer(this.Map, null, {
            averageCenter: true,
            imagePath: this.provider.options.ClustersOpt.Google.ClusterImagePath,
            imageExtension: this.provider.options.ClustersOpt.Google.ClusterImageExt
          });
          if ( this.provider.options.ClustersOpt.Google.ClusterMaxZoom ) {
            this.Clusters.setMaxZoom( this.provider.options.ClustersOpt.Google.ClusterMaxZoom );
          }
          if ( this.provider.options.ClustersOpt.Google.ClusterMinSize ) {
            this.Clusters.setMinClusterSize( this.provider.options.ClustersOpt.Google.ClusterMinSize );
          }
          if ( this.provider.options.ClustersOpt.Google.ClusterGridSize ) {
            this.Clusters.setGridSize( this.provider.options.ClustersOpt.Google.ClusterGridSize );
          }
        }

      }

      google.maps.event.clearListeners(this.Data, 'addfeature');
      this.Data.addListener("addfeature", (e) => {
        // create a GoogleMarker wrapper
        let d = this._parseFeatureData(e.feature);
        let gmarker = new GoogleMarker(e.feature.getGeometry().get(), d, this);


        gmarker.on('click', (marker) => {
          this.trigger("selectpoint", gmarker);
        });

        if ( use_cluster ) {
          this.Clusters.addMarker( gmarker.marker );
        }

        // store all marker into a collection
        this._markers[  d[ this.options['markerkey'] ]   ] = gmarker;
        markers.push( gmarker );
      });

      this.Data.addGeoJson( points );

    }

    return markers; // $.map(this._markers, function(val){ return val; });

  };


  /**
   * Clears and removes all marker pin from Map
   */
  clearMarkers() {
    if ( this.Clusters ) {
      this.Clusters.removeMarkers( this.Clusters.getMarkers() );
    }

    if ( this.Data ) {
      if ( this._markers ) {
        for( let code in this._markers ) {
          if ( this._markers.hasOwnProperty(code) ) {
            this._markers[ code ].map = null;
          }
        }

      }

      google.maps.event.clearListeners(this.Data, 'addfeature');
    }

    this._markers = {};

  }


  addMarkersToMap(markers, cluster) {

    const fnAdded = (gmarker) => {
      gmarker.on('click', (marker) => {
        this.trigger("selectpoint", gmarker);
      });

      if ( cluster && this.Clusters ) {
        this.Clusters.addMarker( gmarker.marker );
      }
      let key = gmarker.get( this.options['markerkey'] );

      // store all marker into a collection
      this._markers[ key ] = gmarker;
    };

    // Reset `Data` and manage new Marker
    google.maps.event.clearListeners(this.Data, 'addfeature');
    this.Data.addListener("addfeature", (e) => {
      // create a GoogleMarker wrapper
      let d = this._parseFeatureData(e.feature);
      let gmarker = new GoogleMarker(e.feature.getGeometry().get(), d, this);
      fnAdded( gmarker );
    });

    // Loop on markers
    for ( let marker of markers ) {

      if ( marker instanceof GoogleMarker ) {
        // Add a new GoogleMarker to collection of Markers
        marker.map = this;

        fnAdded( marker );

      } else {
        // Add marker as 'geojson' data
        this.Data.add( marker );

      }

    }

    google.maps.event.clearListeners(this.Data, 'addfeature');
  }

  addIconMarker(lat,lng,{Url,Size}) {
    const detail_marker = {
      url: Url,
      scaledSize: new google.maps.Size(Size.h, Size.w),
    };

    let detailMarker = new google.maps.Marker({
      position: {lat, lng},
      map: this.Map,
      icon: detail_marker
    });
    return detailMarker;
  }

  _parseFeatureData(feature) {
    const data = {};
    feature.forEachProperty( (v, k) => {
      data[ k ] = v;
    });
    return data;
  }


  /**
   * @Override
   */
  on(ev, fn){
    return this.Map.addListener(ev, fn);
  };

  /**
   * @Override
   */
  off(ev){
    if ( typeof ev == 'string' ) {
      google.maps.event.clearListeners(this.Map, ev);
    } else {
      google.maps.event.removeListener(ev);
    }
    return this;
  }


  /**
   * @Override
   */
  trigger(ev, ...args) {
    let E = $.Event(ev);
    let $t = google.maps.event;
    $t.trigger.apply($t, [this.Map, E.type, E, ...args] );
    return this;
  };


  /**
   * @Override
   */
  get viewport(){ return this.bounds; }
  get bounds(){ return JSON.parse( JSON.stringify( this.Map.getBounds() ) ) ; }
  get center(){ return JSON.parse( JSON.stringify( this.Map.getCenter() ) ) ; }

  /**
   * @Override
   */
  drawOnMap(bounds, color, line) {
    if ( ! this.Rectangle ) {
      // create a new Rectangle if doesn't exist
      this.Rectangle = new google.maps.Rectangle();
    }

    this.Rectangle.setOptions({
      strokeColor: line || '#FF0000',
      strokeWeight: 2,
      bounds: bounds,
      fillColor: color || '#000000',
      fillOpacity: 0.2
    });
    this.Rectangle.setMap( this.Map );
    this.Rectangle.setBounds( bounds );
  };


  clone(element, options) {
    return new GoogleMap(this.provider, element, $.extend(true, {}, this.options, options) );
  }

  getBoundsFromCoords(bounds) {

    let sw = new google.maps.LatLng(bounds.south, bounds.west);
    let ne = new google.maps.LatLng(bounds.north, bounds.east);

    return new google.maps.LatLngBounds( sw, ne );
  };


  // Stores MapEngine into MapProvider
  // MapProvider.addEngine("GoogleMap", constructor);

}

export {GoogleMap, GoogleMarker}
